const OneSignalPrompt = {
  mounted() {
    this.initOneSignal()
  },
  initOneSignal() {
    if (typeof(OneSignal) == 'undefined') {
      setTimeout(this.initOneSignal.bind(this), 500)
    } else {
      if (OneSignal.isPushNotificationsSupported()) {
        let force = this.el.dataset["forceDisplay"]
        if (force === "yes") {
          OneSignal.showSlidedownPrompt({force: true})
        } else {
          OneSignal.showSlidedownPrompt()
        }
      } else {
        this.el.innerHTML = this.el.dataset["disabledMessage"]
      }
    }
  }
}


export default { OneSignalPrompt }
